import styled from "styled-components";

export const Container = styled.div`
  // "100%" em vez de largura fixa (era 755px, mesmo problema já corrigido em
  // GraphicPreview/styles.js - ver ContainerGraphicPreview) - o gráfico
  // (Chart.js, responsive:true) encolhe junto com o container de verdade.
  width: 100%;
  padding: 0 0.5rem 0 0;
  max-height: 15.688rem;

  margin: 0;
  gap: 8px;
  display: flex;
  flex-direction: column;

  text-align: left;

  .chart-wrapper {
    width: 100%;
    height: 11.625rem;
    // Sem padding à esquerda (eram 2.5rem/40px) - empurrava o eixo Y bem mais
    // pra dentro que os gráficos Recharts ao lado (Temperatura, Probabilidade
    // de chuva...), desalinhando o início do gráfico com o título acima.

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 1rem;
    background-color: #fff;

  }

  @media (max-width: 760px) {
    // 100% (não mais largura fixa de 640px) - o gráfico (Chart.js,
    // responsive:true) só deve espremer no mobile, não rolar horizontal (ver
    // mesma mudança em GraphicPreview/styles.js e
    // weather-traffic-light/styles.js).
    width: 100%;
  }
`;